import { Form, withFormik } from "formik";
import { useTranslation, withTranslation } from "react-i18next";
import { validateSomething, validateString50 } from "../../Form/Validations";
import DropdownPrime from "../../PrimeComponents/DropdownPrime";
import InputTextPrime from "../../PrimeComponents/InputTextPrime";


const DavisForm = ({ dialogState, handleSubmit, errors, values, setFieldValue }) => {
    const { t } = useTranslation();
    const onChangeStation = ({value}) => {
        setFieldValue("station_id", value.station_id);
        setFieldValue("nombre_sector", value.station_name);
    };
    return (
        <div id="extFormContent2">
            <Form id="davis_form" onSubmit={handleSubmit}>
                <div className="col-12 col-md-12">
                    <label className="boldie" name="sectorDavis">
                        {t("external.station-name")}
                    </label>
                </div>
                <div className="mb-2 col-12 col-md-12 d-block">
                    {dialogState?.davisStations && (
                        <DropdownPrime
                            id='station_id'
                            name="station_id"
                            placeholder={t("node.tipo.STATION")}
                            filter={false}
                            value={dialogState?.davisStations?.find(d => d?.station_id === values?.station_id)}
                            onChange={(e) => onChangeStation(e)}
                            options={dialogState.davisStations} optionLabel="station_name"
                            showClear={false}
                        />
                    )}
                </div>
                {
                    errors.station_id &&
            <div className="mb-2 col-12 d-block">
                <div className="alert alert-warning m-0" role="alert">{t("external.station-name")} {t(errors.station_id)}</div>
            </div>
                }
                <div className="row linea-formulario" />
                <div className="col-12 col-md-12">
                    <label className="boldie" name="sectorDavis">
                        {t("external.sector-name")}
                    </label>
                </div>
                <div className="mb-2 col-12 col-md-12 d-block">
                    <InputTextPrime
                        name="nombre_sector"
                        value={values.nombre_sector}
                        placeholder={t("external.sector-name")}
                        onChange={e => setFieldValue("nombre_sector", e.target.value)}
                    />
                </div>
                {
                    errors.nombre_sector &&
            <div className="mb-2 col-12 d-block">
                <div className="alert alert-warning m-0" role="alert">{t("external.sector-name")}: {t(errors.nombre_sector)}</div>
            </div>
                }
                <div className="row linea-formulario" />
                <div className="col-12 col-md-12">
                    <label className="boldie text-left">
                        {t("external.availableSensors")}
                    </label>
                </div>
                <div className="mb-2 col-12 col-md-12 d-block">
                    <ul>
                        {Object.entries(dialogState.sensorTypes).map((type, id) => {
                            return <li key={id}> {type[1].text} </li>;
                        })}
                    </ul>
                </div>
            </Form>
        </div>
    );
};

const DavisFormikForm = withFormik({
    mapPropsToValues: () => {
        return {
            station_id: null,
            nombre_sector: null,
        };
    },
    validate: (values) => {
        const errors = {};
        if (values) {
            for (const field of Object.keys(values)) {
                if (["station_id"].includes(field)) {
                    const er = validateSomething(values[field]);
                    if (er !== undefined) errors[field] = er;
                } else if (["nombre_sector"].includes(field)) {
                    const er = validateString50(values[field]);
                    if (er !== undefined) errors[field] = er;
                }
            }
        }
        return errors;
    },
    enableReinitialize: true,
    handleSubmit: (values, { props }) => {
        const body = {
            tipo: props.dialogState.dataTipo,
            stationId: values.station_id,
            sectorName: values.nombre_sector,
            nodeName: values.nombre_sector,
            apiKey: props.dialogState.apiKey,
            secretKey: props.dialogState.secretKey,
            locale: props.i18n.language
        };
        props.conectar(body);
    },
})(withTranslation()(DavisForm));

export { DavisFormikForm };
